export default "__VITE_ASSET__8e36c29e__"